import type {PaginatedResponse, PaginationPropsInterface} from "@/components/helpers/Interfaces.ts";

export function usePagination<T>(response: PaginatedResponse<T>) {
    const data: T[] = response.data

    const pagination: PaginationPropsInterface = {
        currentPage: response.current_page ?? 1,
        lastPage: response.last_page ?? 1,
        perPage: response.per_page ?? 20,
        nextPageUrl: response.next_page_url ?? '',
        prevPageUrl: response.prev_page_url ?? '',
        total: response.total ?? 0
    }


    return {
        data,
        pagination
    }
}
